import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import ProcedurePage from './ProcedurePage';
import ProcedureTabState from './ProcedureTabState';

export default class ProcedureTabView extends BufferTabView<ProcedureTabState> {
  override render(): this {
    const props = {
      procedureId: this.model.get('procedureId'),
      flowchartVersionId: this.model.get('versionApiId'),
    };
    renderToDOM(<ProcedurePage {...props} />, this.el);
    return this;
  }

  override remove(): Backbone.View<ProcedureTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ProcedureTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
